import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { LivetvDTO } from "./dto/livetv.dto";


export class livetvResponseModel extends GlobalResponseObject{
    data?:any;
    response:any;
  }
  export class AlllivetvResponseModel extends GlobalResponseObject {
    data?:any[];
}
export class livetvstatusResponseModel extends GlobalResponseObject {
    data?:LivetvDTO;
}
